import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import './contact.css'

import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import {SiFiverr} from 'react-icons/si'

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_u5cyu36', 'template_0dm8dnd', form.current, 'Jjh1PVkv4mQ9dUVXf')
    
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      })
      e.target.reset();}
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineEmail className='icon'/>
            <h4>Email</h4>
            <h5>noor.alam.619@gmail.com</h5>
            <a href="mailto:noor.alam.619@gmail.com">Send Message</a>
          </article>
          <article className="contact_option">
            <BsWhatsapp className='icon'/>
            <h4>Whatsapp</h4>
            <h5>+917903350593</h5>
            <a href="https://wa.me/7903350593?text=hii%20noor" target='_blank' rel='noreferrer'>Send Message</a>
          </article>
          <article className="contact_option">
            <SiFiverr className='icon'/>
            <h4>Fiver |Hire Me</h4>
            <h5>nooralam826</h5>
            <a href="https://www.fiverr.com/nooralam826" target='_blank' rel='noreferrer'>Send Message</a>
          </article>
        </div>
        {/* end of the contact options */}

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Enter Your Email' required />
          <textarea name='msg'   rows="7"></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact